// extracted by mini-css-extract-plugin
export var bodySections = "_ax-8";
export var gray = "_ax-7";
export var green = "_ax-4";
export var iconContainer = "_ax-9";
export var iconWidgetContainer = "_ax-1";
export var phoneIcon = "_ax-2";
export var red = "_ax-5";
export var statusDot = "_ax-3";
export var widgetContainer = "_ax-0";
export var yellow = "_ax-6";